import { render, staticRenderFns } from "./Chooser.vue?vue&type=template&id=9b2c4640&scoped=true"
import script from "./Chooser.vue?vue&type=script&lang=js"
export * from "./Chooser.vue?vue&type=script&lang=js"
import style0 from "./Chooser.vue?vue&type=style&index=0&id=9b2c4640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2c4640",
  null
  
)

export default component.exports